// extracted by mini-css-extract-plugin
module.exports = {"varFontSize200":"var(--tkww-union-typography-scale-200-font-size, 0.875rem)","guestStatusDot":"guestStatusDot--d189d","guestStatusLabel":"guestStatusLabel--7af3a"};